import { backendApi } from "../dynamicBAseQuery";

export const JobReferralPaymentApi = backendApi.injectEndpoints({
    overrideExisting: true,
    endpoints: (builder) => ({
        JobReferralPaymentsList: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: "jobDetailsForPaymentProcess",
                params: args
            })
        }),
        candidateAllReferralCommission: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: "candidateAllReferralCommission",
                body: { ...args }
            })
        }),
        clientAllReferralCommission: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: "clientAllReferralCommission",
                body: { ...args }
            })
        }),

        getReferralByProfile: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: "getReferralByProfile",
                body: { ...args }
            })
        }),
        getBusinessAssociatePaymentApp: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: "getBusinessAssociatePaymentApp",
                body: { ...args }
            })
        }),
        getRecruiterAllReferralCommissionApp: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: "getRecruiterAllReferralCommissionApp",
                body: { ...args }
            })
        }),
        getAllPaidAmountListApp: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: "getAllPaidAmountListApp",
                body: { ...args }
            })
        }),
        getAllUnPaidAmountListApp: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: "getAllUnPaidAmountListApp",
                body: { ...args }
            })
        }),
        getRecruiterRefundAmountList: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: "getRecruiterRefundAmountList",
                body: { ...args }
            })
        }),
        getCommissionCaptureByProfile: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: "getCommissionCaptureByProfile",
                body: { ...args }
            })
        }),
    })
})

export const {
    useJobReferralPaymentsListMutation,
    useCandidateAllReferralCommissionMutation,
    useClientAllReferralCommissionMutation,
    useGetReferralByProfileMutation,
    useGetBusinessAssociatePaymentAppMutation,
    useGetRecruiterAllReferralCommissionAppMutation,
    useGetAllPaidAmountListAppMutation,
    useGetAllUnPaidAmountListAppMutation,
    useGetRecruiterRefundAmountListMutation,
    useGetCommissionCaptureByProfileMutation
} = JobReferralPaymentApi